import { Component } from '@angular/core';
import {combineLatestWith, Subscription} from "rxjs";
import {GameService} from "../../../../services/game.service";
import {ProviderModel} from "../../../../models/provider.model";
import {Game} from "../../../../models/game.class";
import {Router} from "@angular/router";

@Component({
  selector: 'app-favourites',
  templateUrl: './favourites.component.html',
  styleUrls: ['./favourites.component.scss']
})
export class FavouritesComponent {

  favouriteGames: Game[] = [];
  favouriteIds: number[] = [];

  gamesAndFavouriteIdsSubs?: Subscription;

  randomGamesForCarousel: Game[] = [];
  // providers: ProviderModel[] = [];
  // providerSubs: Subscription;


  constructor(
    private gameService: GameService,
    private router: Router
  ) {
    // this.providerSubs = this.gameService.providers$.subscribe(p => {
    //   this.providers = p.filter(p => p.gameList && p.gameList.length)
    //   if (!this.providers.length) {
    //     this.providers = this.gameService.providers;
    //   }
    // })

  }

  ngOnInit(){
    this.gamesAndFavouriteIdsSubs = this.gameService.getGames().pipe(
      combineLatestWith(this.gameService.favouriteGameIds$)
    ).subscribe(([games, favouriteGameIds]) => {
      if (games && games.length && favouriteGameIds) {
        this.favouriteIds = favouriteGameIds;

        this.favouriteGames = [];
        for (const id of favouriteGameIds) {
          const game = games.getById(id)
          if(game){
            this.favouriteGames.push(game)
          }
        }

        //random games are refreshed each time favourites change
        this.randomGamesForCarousel = this.gameService.pickRandomGames(games.all, 16);
      }
    })


  }

  launchGame(id:number): void {
    let chosenGame = this.favouriteGames.find(g=>g.id === id);
    if (chosenGame && chosenGame.enabled !== false){
      // chosenGame.enabled is "undefined" for Rival brands and "true" for enabled games in gamingpodium brands
      if(chosenGame.launchUrl){
        this.router.navigate(['play', chosenGame.slug])
      } else {
        this.router.navigate(['details', chosenGame.slug])
      }
    }
  }

  ngOnDestroy(){
    this.gamesAndFavouriteIdsSubs?.unsubscribe();
    // this.providerSubs?.unsubscribe();
  }


}
